import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import axios from '../utils/custom_axios'

Vue.use(VueRouter)

const pcLayout = resolve => require(['@/pages/pc/layout'], resolve)
// const register = () => ({
//   // 需要加载的组件 (应该是一个 `Promise` 对象)
//   component: import('../pages/mobile/register'),
//   // 异步组件加载时使用的组件
//   loading: import('../pages/mobile/load'),
//   // 加载失败时使用的组件
//   // error: ErrorComponent,
//   // 展示加载时组件的延时时间。默认值是 200 (毫秒)
//   // delay: 200,
//   // 如果提供了超时时间且组件加载也超时了，
//   // 则使用加载失败时使用的组件。默认值是：`Infinity`
//   timeout: 3000
// })

let routes = []
if ((navigator.userAgent.match(/(test|MicroMessenger|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  // 移动端
  routes = [
    // {
    //   path: '*',
    //   redirect: '/404'
    // },
    // {
    //   path: '/404',
    //   component: resolve => require(['@/pages/not_found'], resolve)
    //   /* component: () => import('../pages/not_found') */
    // },
    {
      path: '/',
      redirect: '/mobile/index'
    },
    {
      path: '/mobile',
      redirect: '/mobile/index'
    },
    {
      path: '/mobile/index',
      component: resolve => require(['@/pages/mobile/index'], resolve)
      /* component: () => import('../pages/mobile/index') */
    },
    {
      path: '/mobile/register',
      component: resolve => require(['@/pages/mobile/register'], resolve),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    // {
    //   path: '/mobile/register',
    //   component: () => ({
    //     // 需要加载的组件 (应该是一个 `Promise` 对象)
    //     component: import('../pages/mobile/register'),
    //     // 异步组件加载时使用的组件
    //     loading: import('../pages/mobile/load'),
    //     // 加载失败时使用的组件
    //     // error: ErrorComponent,
    //     // 展示加载时组件的延时时间。默认值是 200 (毫秒)
    //     // delay: 200,
    //     // 如果提供了超时时间且组件加载也超时了，
    //     // 则使用加载失败时使用的组件。默认值是：`Infinity`
    //     timeout: 3000
    //   }),
    //   meta: {
    //     keepAlive: true // 需要被缓存
    //   }
    // },
    {
      path: '/mobile/land',
      component: resolve => require(['@/pages/mobile/land'], resolve)
      /* component: () => import('../pages/mobile/land') */
    },
    {
      path: '/mobile/detail',
      component: resolve => require(['@/pages/mobile/detail'], resolve)
      /* component: () => import('../pages/mobile/detail') */
    },
    {
      path: '/mobile/map',
      component: resolve => require(['@/pages/mobile/map'], resolve)
      /* component: () => import('../pages/mobile/map') */
    },
    {
      path: '/mobile/msg_list',
      component: resolve => require(['@/pages/mobile/msg_list'], resolve)
      /* component: () => import('../pages/mobile/msg_list') */
    },
    {
      path: '/mobile/member_info',
      component: resolve => require(['@/pages/mobile/member_info'], resolve)
      /* component: () => import('../pages/mobile/member_info') */
    },
    {
      path: '/mobile/area_land',
      component: resolve => require(['@/pages/mobile/area_land'], resolve),
      /* component: () => import('../pages/mobile/area_land'), */
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: '/mobile/setting',
      component: resolve => require(['@/pages/mobile/setting'], resolve)
      /* component: () => import('../pages/mobile/setting'), */
    },
    {
      path: '/mobile/home',
      component: resolve => require(['@/pages/mobile/home'], resolve)
      /* component: () => import('../pages/mobile/home'), */
    }
  ]
} else {
  routes = [
    {
      path: '/login',
      component: resolve => require(['@/pages/pc/login'], resolve)
      /* component: () => import('../pages/pc/login') */
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/404',
      component: resolve => require(['@/pages/not_found'], resolve)
      /* component: () => import('../pages/not_found') */
    },
    {
      path: '/',
      redirect: '/index',
      // component: pcLayout,
      // resolve => require(['@/pages/pc/layout'], resolve)
      component: () => import('@/pages/pc/layout'),
      children: [
        {
          path: '/index',
          component: resolve => require(['@/pages/pc/index/index'], resolve)
          /* component: () => import('../pages/pc/index/index') */
        }
      ]
    },
    {
      path: '/role',
      redirect: '/role/index',
      component: pcLayout,
      children: [
        {
          path: '/role/index',
          component: resolve => require(['@/pages/pc/role/index'], resolve)
          /* component: () => import('../pages/pc/role/index') */
        }, {
          path: '/role/add',
          component: resolve => require(['@/pages/pc/role/add'], resolve)
          /* component: () => import('../pages/pc/role/add') */
        }, {
          path: '/role/edit',
          component: resolve => require(['@/pages/pc/role/edit'], resolve)
          /* component: () => import('../pages/pc/role/edit') */
        }
      ]
    },
    {
      path: '/user',
      redirect: '/user/index',
      component: pcLayout,
      children: [
        {
          path: '/user/index',
          component: resolve => require(['@/pages/pc/user/index'], resolve)
          /* component: () => import('../pages/pc/user/index') */
        }, {
          path: '/user/add',
          component: resolve => require(['@/pages/pc/user/add'], resolve)
          /* component: () => import('../pages/pc/user/add') */
        }, {
          path: '/user/edit',
          component: resolve => require(['@/pages/pc/user/edit'], resolve)
          /* component: () => import('../pages/pc/user/edit') */
        }
      ]
    },
    {
      path: '/member',
      redirect: '/member/index',
      component: pcLayout,
      children: [
        {
          path: '/member/index',
          component: resolve => require(['@/pages/pc/member/index'], resolve)
          /* component: () => import('../pages/pc/member/index') */
        },
        {
          path: '/member/examine',
          component: resolve => require(['@/pages/pc/member/examine'], resolve)
          /* component: () => import('../pages/pc/member/examine') */
        }
      ]
    }
  ]
}

const router = new VueRouter({
  mode: 'history',
  base: './',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const reg = /^\/mobile\/.*/
  if (!(navigator.userAgent.match(/(test|MicroMessenger|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    // 如果是电脑端
    console.log('电脑端', to.path, reg.test(to.path))
    if (!reg.test(to.path)) {
      console.log('电脑端 信息', store.state.userInfo, to.path)
      // 判断登录
      if (store.state.userInfo == null && to.path !== '/login') {
        next('/login')
      } else if (store.state.userInfo != null && to.path === '/login') {
        next('/')
      } else if (to.path !== '/404' && to.path !== '/login' && to.path !== '/' && to.path !== '/index' && verifyUri(to.path)) {
        next('/')
      } else {
        next()
      }
    } else {
      // 如果是电脑端打开移动端跳到首页
      next('/')
    }
  } else {
    // 如果是移动端
    const code = to.query.code
    if (store.state.openId == null && typeof (code) === 'undefined') {
      let recordIdStr = ''
      if (to.query.recordId !== 'undefined' && to.query.recordId !== '' && to.query.recordId != null) {
        recordIdStr = '&recordId=' + to.query.recordId
      }
      // let toQuery = encodeURI(JSON.stringify(to.query));
      location.href = process.env.VUE_APP_SERVER_URL + '/wx/authCode?toPath=' + to.path + recordIdStr
    } else {
      if (store.state.openId != null && store.state.userInfo == null) {
        // 某些情况下获取用户信息
        axios.get(process.env.VUE_APP_SERVER_URL + '/member/findByOpenId', { params: { openId: store.state.openId } }).then((response) => {
          if (response.data.type === 'success') {
            if (response.data.content) {
              sessionStorage.setItem('userInfo', JSON.stringify(response.data.content))
              store.state.userInfo = response.data.content
            }
            next()
          } else {
            alert(response.data.msg)
          }
        })
      } else {
        console.log(to, from)
        next()
      }
    }
  }
}
)

function verifyUri (toPath) {
// 判断数据库角色包含该菜单
  return store.state.roleList.findIndex((role) => role.uri === toPath) < 0
}

export default router
